var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesheetApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1035 0H2.84692C1.27746 0 0 1.27746 0 2.84691V19.0159C0 20.5854 1.27746 21.8628 2.84692 21.8628H18.067C19.6364 21.8628 20.9139 20.5854 20.9139 19.0159V2.84691C20.9504 1.27746 19.6729 0 18.1035 0ZM17.1545 17.1545C17.1545 17.6655 16.7165 18.1035 16.2055 18.1035H4.74486C4.23387 18.1035 3.79589 17.6655 3.79589 17.1545V16.2055C3.79589 15.6945 4.23387 15.2565 4.74486 15.2565H16.169C16.68 15.2565 17.118 15.6945 17.118 16.2055V17.1545H17.1545ZM17.1545 11.4242C17.1545 11.9351 16.7165 12.3731 16.2055 12.3731H4.74486C4.23387 12.3731 3.79589 11.9351 3.79589 11.4242V10.4752C3.79589 9.9642 4.23387 9.52621 4.74486 9.52621H16.169C16.68 9.52621 17.118 9.9642 17.118 10.4752V11.4242H17.1545ZM17.1545 5.73033C17.1545 6.24131 16.7165 6.6793 16.2055 6.6793H4.74486C4.23387 6.6793 3.79589 6.24131 3.79589 5.73033V4.74486C3.79589 4.23387 4.23387 3.79589 4.74486 3.79589H16.169C16.68 3.79589 17.118 4.23387 17.118 4.74486V5.73033H17.1545Z",
    fill: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetApproval);
export default __webpack_public_path__ + "static/media/timesheet-approval.10a516551c081c4d83c0b500526225d0.svg";
export { ForwardRef as ReactComponent };